import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";

import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Manifesto from "@/components/landing/Manifesto";
import Services from "@/components/landing/Services";
import Experience from "@/components/landing/Experience";
import TechMarquee from "@/components/landing/TechMarquee";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#070708] text-white min-h-screen antialiased selection:bg-cyan-400 selection:text-black">
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121214",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "#fff",
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "13px",
            borderRadius: "2px",
          },
        }}
      />
      <Nav />
      <main>
        <Hero />
        <Manifesto />
        <Services />
        <Experience />
        <TechMarquee />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
